import {
  BodyText,
  DetailText,
  Heading,
  Tab,
  TabContent,
  TabsList,
} from '@utilitywarehouse/hearth-react';
import { Formik, useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';

import { FormikPersist } from '@components/FormikPersist';
import { CBC_CALC } from '@constants/formNames';
import { FormSync } from '@features/Remote/Interaction/FormSync';
import { useTrackSignupCbcCalcInteractedWith } from '@tracking/trackingEvents';
import { formatNumber } from '@utils/format';

import { useCashbackCalculatorContext } from '../CalculatorProvider/CalculatorContext';
import { IncludeCashbackWatcher } from '../IncludeCashbackWatcher/IncludeCashbackWatcher';
import { Panel, PanelContent, PanelFooter, PanelHeading } from '../Panel/Panel';
import { SpendBrand } from '../SpendBrand/SpendBrand';
import { SpendCategory } from '../SpendCategory/SpendCategory';
import { type CalculatorFields, SpendType } from '../types';
import { useLoadCbcCalculatorValues } from '../useLoadCbcCalculatorValues';

const SpendForm = () => {
  useLoadCbcCalculatorValues();
  const { handleSubmit, dirty } = useFormikContext<CalculatorFields>();
  const { formRef } = useCashbackCalculatorContext();
  const touchedRef = useRef(false);
  const trackSignupCbcCalcInteractedWith =
    useTrackSignupCbcCalcInteractedWith();

  useEffect(() => {
    if (dirty && !touchedRef.current) {
      trackSignupCbcCalcInteractedWith();
    }
    touchedRef.current = dirty;
  }, [dirty, trackSignupCbcCalcInteractedWith]);

  return (
    <>
      <FormikPersist name={CBC_CALC} />
      <FormSync />
      <IncludeCashbackWatcher />

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
        ref={formRef}
      >
        <TabContent value="category">
          <SpendCategory />
        </TabContent>
        <TabContent value="brand">
          <SpendBrand />
        </TabContent>
      </form>
    </>
  );
};
const Spend = () => {
  const {
    setCurrentSpendCalc,
    currentSpendCalc,
    output,
    initialFormValues,
    saveForm,
  } = useCashbackCalculatorContext();

  return (
    <Panel
      value={currentSpendCalc}
      defaultValue={SpendType.Category}
      onValueChange={(value) => setCurrentSpendCalc(value as SpendType)}
    >
      <PanelHeading>
        <Heading size="md" className="cbcCalculator__PanelHeading">
          How much do you spend monthly?
        </Heading>
        <TabsList className="cbcCalculator__PanelTabs">
          <Tab value="category">By category</Tab>
          <Tab value="brand">By brand</Tab>
        </TabsList>
      </PanelHeading>
      <PanelContent>
        <Formik initialValues={initialFormValues} onSubmit={saveForm}>
          <SpendForm />
        </Formik>
      </PanelContent>
      <PanelFooter>
        <BodyText size="lg" weight="semibold">
          Total monthly spending
        </BodyText>
        <DetailText size="2xl">
          £{formatNumber(output[currentSpendCalc].total.spend)}
        </DetailText>
      </PanelFooter>
    </Panel>
  );
};
export { Spend };
